import dayjs from "dayjs";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

const TICK = { fill: "#64748B", fontSize: 10, fontFamily: "JetBrains Mono" };

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-[#2A364F] bg-[#0F131D] px-3 py-2 font-mono text-xs">
      <p className="text-slate-400">{dayjs(label).format("MMM D, YYYY")}</p>
      <p className="font-bold text-[#00E676]">{payload[0].value > 0 ? "+" : ""}{payload[0].value}U</p>
    </div>
  );
}

export function CumulativeChart({ points = [] }) {
  return (
    <div className="card-mp mt-8 p-5 sm:p-6" data-testid="cumulative-chart">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-display text-lg font-bold uppercase tracking-wide text-white">Cumulative Units</h3>
        <span className="font-mono text-[10px] uppercase tracking-wider text-slate-500">Season to date</span>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={points} margin={{ top: 5, right: 8, left: -18, bottom: 0 }}>
            <defs>
              <linearGradient id="mpUnits" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#00E676" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#00E676" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" tick={TICK} tickFormatter={(d) => dayjs(d).format("MMM D")} axisLine={{ stroke: "#1E2738" }} tickLine={false} minTickGap={40} />
            <YAxis tick={TICK} axisLine={false} tickLine={false} />
            <Tooltip content={<ChartTooltip />} />
            <ReferenceLine y={0} stroke="#2A364F" strokeDasharray="4 4" />
            <Area type="monotone" dataKey="units" stroke="#00E676" strokeWidth={2} fill="url(#mpUnits)" dot={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
